export default {
  label: {
    myReport: 'My Report'
  }
}
